import { Loader2, ShieldAlert } from 'lucide-react';

const LAYER = 'fixed inset-0 z-[2147483000] flex items-center justify-center bg-background/70 p-6 backdrop-blur-2xl';

const StrikeMeter = ({ strikes, limit }) => (
    <div className="flex items-center justify-center gap-2" data-testid="focus-guard-strike-meter">
        {Array.from({ length: limit }, (_, i) => (
            <span key={i} className={`h-2.5 w-8 rounded-full transition-colors duration-300 ${i < strikes ? 'bg-red-500' : 'bg-muted-foreground/25'}`} />
        ))}
    </div>
);

// Covers (and blurs) the whole app while the learner is away, and while a strike-out sign-out runs
export const AwayOverlay = ({ away, signingOut, strikes, limit, attemptLabel }) => {
    if (!away && !signingOut) return null;
    const remaining = Math.max(limit - strikes, 0);
    return (
        <div className={LAYER} data-testid={signingOut ? 'focus-guard-signing-out' : 'focus-guard-overlay'} onContextMenu={(e) => e.preventDefault()}>
            <div className="w-full max-w-md space-y-5 rounded-3xl border border-red-500/30 bg-card/95 p-8 text-center shadow-2xl">
                <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-2xl bg-red-500/10 text-red-500">
                    {signingOut ? <Loader2 className="h-7 w-7 animate-spin" /> : <ShieldAlert className="h-7 w-7" />}
                </div>
                {signingOut ? (
                    <>
                        <h2 className="font-heading text-2xl font-bold">Signing you out</h2>
                        <p className="text-sm text-muted-foreground" data-testid="focus-guard-signout-message">
                            You left the page {limit} {limit === 1 ? 'time' : 'times'}.{attemptLabel ? ` Your ${attemptLabel} has been ended.` : ''}
                        </p>
                    </>
                ) : (
                    <>
                        <h2 className="font-heading text-2xl font-bold">Come back to continue</h2>
                        <p className="text-sm text-muted-foreground">You left the training page. Every time you leave the page counts as a strike.</p>
                        <StrikeMeter strikes={strikes} limit={limit} />
                        <p className="text-sm font-semibold" data-testid="focus-guard-strike-text">Strike {strikes} of {limit}</p>
                        {remaining > 0 && (
                            <p className="text-xs text-muted-foreground" data-testid="focus-guard-remaining">
                                {remaining} more and {attemptLabel ? `your ${attemptLabel} will end and ` : ''}you&apos;ll be signed out.
                            </p>
                        )}
                        <p className="rounded-xl bg-muted/60 px-4 py-2 text-xs text-muted-foreground">Return to this tab and move your mouse back over the page.</p>
                    </>
                )}
            </div>
        </div>
    );
};
